import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { AppTab } from "../../core/app-tab";
import { ShowRequest } from "../../core/show-request";
import { RutCallLogTableComponent } from "./rut-call-log-table.component";
import { RutCallLogViewRecord } from "../../core/models/rut-call-log-record";

@Component({
  selector: "app-rut-call-log",
  templateUrl: "./rut-call-log.component.html",
})
export class RutCallLogComponent implements OnInit {
  //
  // These @Input values get passed in from home.html and passed to the table component
  //

  @Input() tabConfig: AppTab;

  @Input() detailFn: (vi: ShowRequest) => void;

  @Input() isActiveView: boolean;

  @Input() contextJson: string;

  @Input() loadOnInit: boolean;

  @Input() contextJsonChangeHandler: (itemId: string, tab: AppTab) => void;

  @Input() alternateViewsEnabled: boolean = true;

  @ViewChild('table') table: RutCallLogTableComponent;

  @Output() rowMouseOverEmitter = new EventEmitter<{record:RutCallLogViewRecord,event:MouseEvent}>();
  @Output() rowMouseOutEmitter = new EventEmitter<{record:RutCallLogViewRecord,event:MouseEvent}>();

  constructor() {}

  ngOnInit(): void {}
}
